import { render, staticRenderFns } from "./client-summary.vue?vue&type=template&id=3ce269da&"
import script from "./client-summary.vue?vue&type=script&lang=ts&"
export * from "./client-summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports